export default {
  mounted() {
    this.setOffset()
    window.addEventListener('resize', this.setOffset)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setOffset)
  },
  methods: {
    setOffset() {
      this.$store.dispatch('setOffset', {
        block: this.$options.name,
        value: this.$refs.anchor.offsetTop,
      })
    },
  },
}
